import type { ProductListItem } from 'types/capi/shared';
import type { User } from 'types/User';

import algolia from '~/services/algolia.client';

import UserEvent from './UserEvent';

type EventData = {
  isBot: boolean;
  product: ProductListItem;
  surface: string;
  user: User;
};

class ProductCardClickEvent extends UserEvent<EventData> {
  sendToAlgolia() {
    if (!this.data.product.queryID) return;
    if (!this.data.product.position) return;

    algolia.clickedObjectIdAfterSearch({
      id: this.data.product.id.toString(),
      position: this.data.product.position,
      queryID: this.data.product.queryID,
      user: this.data.user
    });
  }

  collectServerEvents() {
    this.serverEvents.push({
      data: {
        is_logged_in: this.data.user.isLoggedIn,
        position: this.data.product.position,
        product_id: this.data.product.id,
        stock_status: this.data.product.stock_status,
        surface: this.data.surface
      },
      type: 'product_card_click'
    });
  }
}

export default ProductCardClickEvent;
